import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  fetchBranches = signal<Branch[]>([])
  filtered: boolean = false

  searchQuery = signal<string>('')

  items = computed( () => {
    const sq = this.searchQuery().toLowerCase()
    let results: Branch[] = this.fetchBranches()

    return [...new Set(results.filter( branch => branch.locationName.toLowerCase().includes(sq.trim()) || branch.address.toLowerCase().includes(sq.trim())))]
  })

  get BranchName() {
    return this.items()
  }

}
